interface FilterOption {
  label: string;
  value: string;
}

interface FilterBarProps {
  title: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterBar({ title, options, value, onChange }: FilterBarProps) {
  return (
    <div className="flex items-start gap-3 md:gap-5">
      <span className="shrink-0 pt-1.5 text-sm text-foreground-400 w-10 md:w-12">{title}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={`h-8 px-3 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                active
                  ? 'bg-primary-500 text-background-50 font-medium'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}